define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const dom = require('util/dom.util');
    const ValidationUtil = require('util/validation.util');

    ValidationUtil.validateDomField = function($field, options) {
        if (!options || !options.validationConfig) {
            return $.Deferred().reject();
        }

        let inputs = ['input', 'select', 'textarea'];
        let selector = inputs.reduce(function(memo, input) {
            return memo.concat(
                input + ':not([disabled])',
                input + '.progress:disabled'
            );
        }, []).join(', ');
        let validationType = $field && $field.length > 0 && $field[0].dataset?.validationType || '';
        let $inputs = $($field.find(selector).filter(function(el) {
            return !el.classList.contains('no-validate');
        }));

        if (!$inputs.length) {
            return $.Deferred().resolve();
        }

        let values = $inputs.map(dom.getInputValidationValue);

        return this._validateField(_.extend({}, options, {
            values: values,
            $inputs: $inputs,
            validationType: validationType,
            validationConfig: options.validationConfig
        }));
    };

    module.exports = ValidationUtil;
});
